<template>
    <div class="filter-wrapper" v-show="facets && facets.length > 0">
        <a class="category__filter-btn filter-toggle" data-toggle="collapse" :href="'#filterCollapse'"
            aria-expanded="false" :aria-controls="'filterCollapse'" @click="toggleOpeningState()">
            <i class="fa fa-sliders default-float" aria-hidden="true"></i> {{ $translate("Ceres::Template.itemFilter")
            }}
        </a>

        <div v-open-filter-toolbar class="filter-collapse collapse" :id="'filterCollapse'">
            <div class="container-max page-content component-loading filter__wrapper"
                :class="{ 'isLoading': isLoading }">
                <div class="filter">
                    <item-filter v-for="facet in facets" :facet="facet" :key="facet.id"></item-filter>
                </div>

                <div class="row">
                    <div class="col-12 text-right">
                        <button v-if="!isDesktop" type="button" class="category__filter-btn-close-or-accept d-none"
                            data-toggle="collapse" :href="'#filterCollapse'" :aria-controls="'filterCollapse'"
                            @click="toggleOpeningState()">
                            <i :class="{ 'fa-times': isInitialFacetSelectionActive, 'fa-check': !isInitialFacetSelectionActive }"
                                class="fa" aria-hidden="true"></i>
                            <span v-if="isInitialFacetSelectionActive">{{ $translate("Ceres::Template.itemClose")
                                }}</span>
                            <span v-else>{{ $translate("Ceres::Template.itemFilterApply") }}</span>
                        </button>

                        <button v-else-if="isDesktop && !isInitialFacetSelectionActive" type="button"
                            class="category__filter-btn-close-or-accept d-none" @click="toggleOpeningState()">
                            <span>{{ $translate("Ceres::Template.itemFilterApply") }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ItemFilter from "./ItemFilter.vue";
import { ComponentIdMixin } from "ceres/app/mixins/componentId.mixin";

export default {

    name: "item-filter-list",

    components:
    {
        ItemFilter
    },

    mixins: [ComponentIdMixin], // Experimental mixin, may be removed in the future.

    props: {
        filterListBulk: Boolean,
        facetData:
        {
            type: Array,
            default() {
                return [];
            }
        },
        allowedFacetsTypes:
        {
            type: Array,
            default: () => []
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        }
    },

    data() {
        return {
            initialSelectedFacets: [],
            initialPriceMin: "",
            initialPriceMax: "",
            isDesktop: false
        };
    },

    computed:
    {
        isInitialFacetSelectionActive() {
            if (!this.isInitialPriceFacetActive) {
                return false;
            }

            const selectedFacetIds = this.selectedFacets.map(facet => facet.id);

            if (this.initialSelectedFacets.length === selectedFacetIds.length) {
                for (const selectedFacetId of selectedFacetIds) {
                    if (!this.initialSelectedFacets.find(initialFacetId => initialFacetId.toString() === selectedFacetId.toString())) {
                        return false;
                    }
                }

                return true;
            }

            return false;
        },

        isInitialPriceFacetActive() {
            const currentPriceFacet = this.selectedFacets.filter(facet => facet.id === "price")[0];

            // no initial price facet and no current one
            if (!this.initialPriceMin && !this.initialPriceMax && !currentPriceFacet) {
                return true;
            }

            if (currentPriceFacet) {
                if (currentPriceFacet.priceMin === this.initialPriceMin && currentPriceFacet.priceMax === this.initialPriceMax) {
                    return true;
                }
            }

            return false;
        },

        ...mapState({
            facets(state) {
                if (!this.allowedFacetsTypes.length) {
                    return state.itemList.facets;
                }

                return state.itemList.facets
                    .filter(facet => this.allowedFacetsTypes.includes(facet.id) || this.allowedFacetsTypes.includes(facet.type));
            },
            isLoading: state => state.itemList.isLoading,
            selectedFacets: state => state.itemList.selectedFacets
        })
    },

    mounted() {

        this.$nextTick(() => {
            this.isDesktop = window.innerWidth > 991;


            setTimeout(function () {
                let filters = document.getElementsByClassName("findologic-filter-wrapper")[0].getElementsByClassName("card")

                for (let key in filters) {
                    if (filters[key].lastChild && filters[key].lastChild.firstChild) {
                        filters[key].lastChild.style.height = filters[key].lastChild.firstChild.clientHeight + 'px'
                    }
                }
            }, 500);
        });
    },

    created() {
        if (!this.$store.state.itemList.facets?.length) {
            this.$store.commit("addFacets", this.facetData);
        }
    },

    methods:
    {
        initPriceFacet(urlParams) {
            if (urlParams.priceMin || urlParams.priceMax) {
                const priceMin = urlParams.priceMin || "";
                const priceMax = urlParams.priceMax || "";

                this.$store.commit("setPriceFacet", { priceMin: priceMin, priceMax: priceMax });

                this.initialPriceMin = priceMin;
                this.initialPriceMax = priceMax;

                return true;
            }

            return false;
        },

        toggleOpeningState() {
            window.setTimeout(() => {
                if (this.isActive && !this.isInitialFacetSelectionActive) {
                    this.$store.dispatch("loadItemList");
                }

                this.isActive = !this.isActive;
            }, 300);
        }
    }
}
</script>
